import SkapaTextArea, {
  type TextAreaAttributes,
  type TextAreaProps,
} from "@ingka/text-area";

export const TextArea = (props: TextAreaProps & TextAreaAttributes) => {
  return <SkapaTextArea prefix="saleslead__" {...props} autoComplete="off" />;
};
